module.exports = __webpack_public_path__ + "img/imdb-black-square.aa8a72d0.svg";